function WhySection() {
  return (
    <section id="why" className="section">
      <div className="split">
        <div>
          <p className="eyebrow">Why GURU KRIPA?</p>
          <h2>Reliable Technicians with Modern Tools</h2>
          <p className="subtitle">
            We combine experience with modern diagnostic equipment to deliver speedy,
            trustworthy repairs. Our team values your time and safety.
          </p>
          <ul className="checklist">
            <li>On-time arrival with safety gear</li>
            <li>Upfront estimates and warranty on work</li>
            <li>Customer support before and after service</li>
          </ul>
        </div>
        <div className="info-panel">
          <h3>Service Highlights</h3>
          <div className="info-item">
            <span>45 min</span>
            <p>Average response time</p>
          </div>
          <div className="info-item">
            <span>100%</span>
            <p>Customer satisfaction focus</p>
          </div>
          <div className="info-item">
            <span>365 days</span>
            <p>Emergency support coverage</p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default WhySection;
